/**
 * VIP System Configuration Constants
 *
 * These constants define the VIP level calculation system based on:
 * - RMV token balance
 * - World NFT ownership
 */

export const VIP_SYSTEM = {
  /** Token ID for World NFTs that contribute to VIP points */
  WORLD_NFT_TOKEN_ID: '5000',

  /** Points awarded per World NFT owned (200,000 RMV equivalent) */
  POINTS_PER_WORLD_NFT: 200_000,

  /** Maximum points required to achieve VIP Level 1 */
  MAX_POINTS: 1_000_000,

  /** Default VIP level */
  DEFAULT_VIP_LEVEL: 1,
} as const;

export type VipSystemConfig = typeof VIP_SYSTEM;
